import * as THREE from 'three';
function createGradientTexture(mixAmount, leftColor = "rgba(255, 255, 255, 0)", rightColor = "rgba(255, 255, 255, 1)") {
  const canvas = document.createElement("canvas");
  canvas.width = 256;
  canvas.height = 256;
  const ctx = canvas.getContext("2d");

  const gradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
  
  // Reverse the gradient transition
  const mix = 1 - mixAmount / 100;
  
  gradient.addColorStop(0, leftColor);
  gradient.addColorStop(mix, leftColor);
  gradient.addColorStop(mix, rightColor);
  gradient.addColorStop(1, rightColor);

  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  const texture = new THREE.CanvasTexture(canvas);
  texture.needsUpdate = true;
  return texture;
}

export default createGradientTexture;
